import {head} from 'ramda';

import {ListEmailCredentialsResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

type Mailbox = Pick<
  ListEmailCredentialsResponseBody['credentials'][number],
  'id' | 'isDefault' | 'emailAddress'
>;

/**
 * Picks the mailbox to preselect when composing an email.
 *
 * Precedence: a mailbox matching a preferred address, then the mailbox last used for this kind of message, then the mailbox
 * the user marked as default, then the first connected mailbox.
 */
export const resolveDefaultMailboxId = (
  mailboxes: Mailbox[],
  lastUsedMailboxId: string | Nullish,
  preferredAddresses: string[] = []
) => {
  const preferredMailbox = mailboxes.find((mailbox) =>
    preferredAddresses.some(
      (address) => address.trim().toLowerCase() === mailbox.emailAddress.trim().toLowerCase()
    )
  );
  const lastUsedMailbox = mailboxes.find((mailbox) => mailbox.id === lastUsedMailboxId);
  const userDefaultMailbox = mailboxes.find((mailbox) => mailbox.isDefault);

  return (
    preferredMailbox?.id ?? lastUsedMailbox?.id ?? userDefaultMailbox?.id ?? head(mailboxes)?.id
  );
};
